import ColaboradoresPontosAdminPage from "@/Pages/Colaboradores/ColaboradoresPontosAdminPage.vue";
import FaltaJustificadaPage from "@/Pages/Colaboradores/FaltaJustificadaPage.vue";
import NovaFaltaJustificadaPage from "@/Pages/Colaboradores/NovaFaltaJustificadaPage.vue";
import GerenciarFaltasJustificadasPage from "@/Pages/Colaboradores/GerenciarFaltasJustificadasPage.vue";
import JustificativaMassaPage from "@/Pages/Colaboradores/JustificativaMassaPage.vue";
import MeusPontosPage from "@/Pages/Colaboradores/MeusPontosPage.vue";
import FeriadosPage from "@/Pages/Feriados/FeriadosPage.vue";
import authService from "@/Services/AuthService";
import store from "@/store";

async function carregarUsuarioAtual() {
  let currentUser = store.getters["Auth/user"];
  if (!currentUser) {
    await authService.syncUserWithStore();
    currentUser = store.getters["Auth/user"];
  }
  return currentUser;
}

function possuiPermissao(currentUser, permissions = []) {
  if (currentUser?.roleName === "super-admin") return true;
  if (!Array.isArray(permissions) || permissions.length === 0) return true;
  return permissions.some((p) => currentUser?.permissions?.includes(p));
}

function possuiPerfil(currentUser, allowedRoles = []) {
  return allowedRoles.includes(currentUser?.roleName);
}

const ROLES_COLABORADORES = [
  "professor",
  "prof-auxiliar",
  "secretario-escolar",
  "coordenador",
  "direção",
];

const ROLES_GESTORES = ["TI", "admin", "super-admin", "coordenador", "direção"];

async function redirecionarSemColaborador(to, from, next) {
  const currentUser = await carregarUsuarioAtual();

  if (
    !possuiPerfil(currentUser, ROLES_COLABORADORES) ||
    !possuiPermissao(currentUser, ["colaboradores.meusPontos"])
  ) {
    return next({ name: "home" });
  }

  return next();
}

async function redirecionarSemPermissaoGestor(to, from, next) {
  const currentUser = await carregarUsuarioAtual();

  if (
    !possuiPerfil(currentUser, ROLES_GESTORES) ||
    !possuiPermissao(currentUser, ["colaboradores.pontos"])
  ) {
    return next({ name: "home" });
  }

  return next();
}

async function redirecionarSemPermissaoFaltaJustificada(to, from, next) {
  const currentUser = await carregarUsuarioAtual();

  if (!possuiPermissao(currentUser, ["colaboradores.faltasJustificadas.solicitar"])) {
    return next({ name: "home" });
  }

  return next();
}

async function redirecionarSemPermissaoGestorFalta(to, from, next) {
  const currentUser = await carregarUsuarioAtual();

  if (!possuiPermissao(currentUser, ["colaboradores.faltasJustificadas.gerenciar"])) {
    return next({ name: "home" });
  }

  return next();
}

async function redirecionarSemPermissaoFeriado(to, from, next) {
  const currentUser = await carregarUsuarioAtual();

  if (!possuiPermissao(currentUser, ["feriados.gerenciar"])) {
    return next({ name: "home" });
  }

  return next();
}

async function redirecionarSemPermissaoJustificativaMassa(to, from, next) {
  const currentUser = await carregarUsuarioAtual();

  if (!possuiPermissao(currentUser, ["colaboradores.justificativaMassa"])) {
    return next({ name: "home" });
  }

  return next();
}

export default [
  {
    path: "/colaboradores/meus-pontos",
    name: "colaboradores.meusPontos",
    component: MeusPontosPage,
    beforeEnter: redirecionarSemColaborador,
  },
  {
    path: "/colaboradores/pontos",
    name: "colaboradores.pontos",
    component: ColaboradoresPontosAdminPage,
    beforeEnter: redirecionarSemPermissaoGestor,
  },
  {
    path: "/colaboradores/faltas-justificadas",
    name: "colaboradores.faltasJustificadas",
    component: FaltaJustificadaPage,
    beforeEnter: redirecionarSemPermissaoFaltaJustificada,
  },
  {
    path: "/colaboradores/faltas-justificadas/nova",
    name: "colaboradores.faltasJustificadas.nova",
    component: NovaFaltaJustificadaPage,
    beforeEnter: redirecionarSemPermissaoFaltaJustificada,
  },
  {
    path: "/colaboradores/faltas-justificadas/gerenciar",
    name: "colaboradores.faltasJustificadas.gerenciar",
    component: GerenciarFaltasJustificadasPage,
    beforeEnter: redirecionarSemPermissaoGestorFalta,
  },
  {
    path: "/admin/feriados",
    name: "feriados.gerenciar",
    component: FeriadosPage,
    beforeEnter: redirecionarSemPermissaoFeriado,
  },
  {
    path: "/colaboradores/justificativas-massa",
    name: "colaboradores.justificativaMassa",
    component: JustificativaMassaPage,
    beforeEnter: redirecionarSemPermissaoJustificativaMassa,
  },
];
